import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchActivePostings, postingLocation } from "services/hiring";
import "assets/styles/hiring.css";

// Home page teaser for current openings; renders nothing when no roles are open.
function OpenRoles() {
  const [postings, setPostings] = useState([]);

  useEffect(() => {
    fetchActivePostings()
      .then(setPostings)
      .catch(() => setPostings([]));
  }, []);

  if (!postings.length) return null;

  return (
    <section className="wrapper bg-light">
      <div className="container pb-14">
        <div className="open-roles-band p-6 p-md-8">
          <div className="row gy-6 align-items-center">
            <div className="col-lg-4">
              <h2 className="fs-16 text-uppercase text-muted mb-2">We're hiring</h2>
              <h3 className="h1 mb-3">Build the future of AI with us</h3>
              <Link to="/join-our-team" className="btn btn-primary rounded contact-us-button">
                See all {postings.length} opening{postings.length > 1 ? "s" : ""}
              </Link>
            </div>
            <div className="col-lg-8">
              <div className="row g-3">
                {postings.slice(0, 4).map((posting) => (
                  <div className="col-md-6" key={posting.id}>
                    <Link to={`/join-our-team/${posting.id}`} className="open-role">
                      <div className="flex-grow-1">
                        <div className="fw-bold">{posting.jobTitle}</div>
                        <div className="fs-14 text-muted">
                          {[posting.jobType, postingLocation(posting)].filter(Boolean).join(" · ")}
                        </div>
                      </div>
                      <i className="fa-solid fa-arrow-right text-primary" />
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default OpenRoles;
